module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("© 2022 Chris Mackowski")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Savas Beatie Battles & Leaders Series")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted, in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior written permission of the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("First edition, first printing")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("ISBN-13 (hardcover): 978-1-61121-655-4")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("ISBN-13 (ebook): 978-1-61121-656-1")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("ISBN-13 (Mobi): 978-1-61121-656-1")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copyit"
  }, [_vm._v("Names: Mackowski, Chris, author.")]), _vm._v(" "), _c('p', {
    staticClass: "copyi"
  }, [_vm._v("Title: The Battle of Jackson, Mississippi, May 14, 1863 / by Christopher Mackowski.")]), _vm._v(" "), _c('p', {
    staticClass: "copyi"
  }, [_vm._v("Description: El Dorado Hills, CA : Savas Beatie LLC, [2022] | Series: Savas Beatie battles & leaders series | Includes bibliographical references and index. | Summary: “Drawing on dozens of primary sources, contextualized by the latest scholarship on Grant’s Vicksburg campaign, The Battle of Jackson, Mississippi, May 14, 1863, offers the most comprehensive account ever published on the fall of the Magnolia State’s capital during Grant’s inexorable march on Vicksburg”--Provided by publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copyi"
  }, [_vm._v("Identifiers: LCCN 2022011319 | ISBN 9781611216554 (hardcover) | ISBN 9781611216561 (ebook)")]), _vm._v(" "), _c('p', {
    staticClass: "copyi"
  }, [_vm._v("Subjects: LCSH: Jackson, Battle of, Jackson, Miss., 1863 (May 13) |Jackson (Miss.)--History--Siege, 1863. | Vicksburg (Miss.)--History--Siege, 1863. | Mississippi--History--Civil War, 1861-1865.")]), _vm._v(" "), _c('p', {
    staticClass: "copyi"
  }, [_vm._v("Classification: LCC E475.29 .M33 2022 | DDC 973.7/344--dc23/ eng/20220314")]), _vm._v(" "), _c('p', {
    staticClass: "copyi"
  }, [_vm._v("LC record available at "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "https://lccn.loc.gov/2022011319",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("https://lccn.loc.gov/2022011319")])])])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerc"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/copy.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Savas Beatie")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("989 Governor Drive, Suite 102")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("El Dorado Hills, CA 95762")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("916-941-6896 / sales@savasbeatie.com / "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.savasbeatie.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.savasbeatie.com")])])])]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("All of our titles are available at special discount rates for bulk purchases in the United States. Contact us for information.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f8513ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Copyright.vue
// module id = 66
// module chunks = 0